"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Datalist = _interopRequireDefault(require("../Datalist"));

var _formUtils = require("../../utils/formUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 *  #### Blue Prism styled `DatalistIndexed` component

The DatalistIndexed component provides a list of options to choose from, like a select, but also provides the ability to search through the options ,like a datalist. Unlike a datalist however, the options take an number index as their value and return that index on `event.target.value`. if the inputted text does not appear in the options list then `undefined` is returned.

 */
var parseChildren = function parseChildren(children) {
  return _react["default"].Children.map(children, function (child) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      'select-value': child.props.value,
      value: null
    });
  });
};

function DatalistIndexed(_ref) {
  var _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
      _ref$onKeyUp = _ref.onKeyUp,
      onKeyUp = _ref$onKeyUp === void 0 ? function () {} : _ref$onKeyUp,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["defaultValue", "error", "onChange", "onBlur", "onFocus", "onKeyUp", "children"]);

  var _React$useState = _react["default"].useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      options = _React$useState2[0],
      setOptions = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(options),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      filteredOptions = _React$useState4[0],
      setFilteredOptions = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(defaultValue),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      value = _React$useState6[0],
      setValue = _React$useState6[1];

  _react["default"].useEffect(function () {
    if (children) {
      var parsedChildren = parseChildren(children);
      setOptions(parsedChildren);
      setFilteredOptions(parsedChildren);
    }
  }, []);

  function parseEvent(event, optionsLength) {
    var newTarget = _objectSpread(_objectSpread({}, event.target), {}, {
      value: undefined,
      name: event.target.name,
      id: event.target.id
    });

    if (optionsLength > 0) {
      var _options$filter = options.filter(function (option) {
        return option.props.children.toLowerCase() === event.target.value.toLowerCase();
      }),
          _options$filter2 = _slicedToArray(_options$filter, 1),
          selectedOption = _options$filter2[0];

      newTarget.value = selectedOption && selectedOption.props['select-value'];
    }

    return (0, _formUtils.cloneEventObj)(event, {
      target: newTarget
    });
  }

  function handleChange(event) {
    setValue(event.target.value);
    var newOptions = options.filter(function (_ref2) {
      var props = _ref2.props;
      return RegExp('^' + event.target.value.toLowerCase()).test(props.children.toLowerCase());
    });
    setFilteredOptions(newOptions);
    onChange(parseEvent(event, event.target.value ? newOptions.length : 0));
  }

  function handleBlur(event) {
    setFilteredOptions(parseChildren(children));
    onBlur(event);
  }

  return /*#__PURE__*/_react["default"].createElement(_Datalist["default"], _extends({
    error: error,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: onFocus,
    onKeyUp: onKeyUp,
    value: value
  }, rest), filteredOptions);
}

var _default = DatalistIndexed;
exports["default"] = _default;